import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Case } from 'src/app/shared/models/cases/case';
import { CaseLawyer } from 'src/app/shared/models/cases/caseLawyer';

@Component({
  selector: 'app-print-file-summary',
  templateUrl: './print-file-summary.component.html',
  styleUrls: ['./print-file-summary.component.scss']
})
export class PrintFileSummaryComponent implements OnInit {
  fileInfo: Case;
  notCRMLawyers: CaseLawyer[] = [];
  CRMLawyers: CaseLawyer[] = [];
  constructor(
    private printService: PrintService,
  ) {
    this.fileInfo = this.printService.data.fileInfo;
    this.CRMLawyers = this.printService.data.CRMLawyers;
    this.notCRMLawyers = this.printService.data.notCRMLawyers;
  }

  ngOnInit(): void {
    this.printService.onDataReady('File Summary');
  }

}
